import { parseItems } from './helpers';
import { formatPrice } from '../helpers/legacy';

export const checkoutForm = ({
  instances = [],
  response: { tracking = {} } = {},
  store: { finder = {}, id, type } = {},
} = {}) => {
  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const { hotelInfo = {}, reservedExtras = {}, reservedRooms = [], totalPriceWithoutTaxes } = tracking;
  const { promocode = '' } = finder;

  const value = {
    coupon: promocode,
    items: parseItems({ finder, hotelInfo, id, reservedExtras, reservedRooms, type }),
    send_to: instances.map(({ idAnalytics } = {}) => idAnalytics),
    value: formatPrice(totalPriceWithoutTaxes, hotelInfo.currency),
  };

  window.gtag('event', 'add_payment_info', value);

  return value;
};
